import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4718235b")

_pushScopeId("data-v-4718235b")
const _hoisted_1 = { class: "bg-ff content" }
const _hoisted_2 = { class: "flex alignC mar-b-30 mar-l-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "padding-30" }
const _hoisted_5 = { class: "flex flexC alignC mar-t-22" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("返回")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_editList = _resolveComponent("editList")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.formRules,
        inline: true,
        "label-width": "120px",
        class: "width-900"
      }, {
        default: _withId(() => [
          _createVNode("div", null, [
            _createVNode(_component_el_form_item, { label: "单据编号" }, {
              default: _withId(() => [
                _createVNode("span", null, _toDisplayString(_ctx.form.purchaes_number), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", null, [
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"600px"},
                  modelValue: _ctx.form.desc,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.desc = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_editList, {
        class: "mar-t-22",
        partsData: _ctx.form.parts,
        show_add: false
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "配件名称",
            prop: "name",
            "mix-width": "450",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "配件分类",
            prop: "mountings_type_p_name",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "mountings_unit_name",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "采购单价",
            prop: "cost_price",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "数量",
            prop: "member",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "已入库",
            prop: "stock_number",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "待入库",
            prop: "refundable_number",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "实际入库",
            width: "120",
            align: "center"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.reality_number,
                "onUpdate:modelValue": ($event: any) => (scope.row.reality_number = $event),
                type: "text",
                class: "mar-l-16",
                style: {"width":"80px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["partsData"]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx._onsubmit
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_directive_loading, _ctx.is_load]
    ])
  ]))
})